import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Listing } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class RatehawkService extends ResourceService<Listing> {
  /**
   * @constructor
   * Creates an instance of the EnquiresService
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
 */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'ratehawk');
  }

 /**
   * Get hotel details of a the listing with @id
   *
   * @param id - The ID of the listing to retrieve it's details.
   * @returns An observable that emits the details of the specified listing.
   */

 getHotelDetailsById(payload: any) {
  return this.http.post(`${this.endpoint}/search/hotelpage`, payload).pipe(
    map((resp: any) => {
      this.cache.remove(`${this.endpoint}/search/hotelpage`);
      this.cache.remove(`${this.endpoint}`);
      return resp;
    })
  );
}

 /**
   * Get hotel details of a the listing with @id
   *
   * @param id - The ID of the listing to retrieve it's details.
   * @returns An observable that emits the details of the specified listing.
   */

 fetchRHAutocomplete(payload: any) {
  return this.http.post(`${this.endpoint}/search/autocomplete`, payload).pipe(
    map((resp: any) => {
      this.cache.remove(`${this.endpoint}/search/autocomplete`);
      this.cache.remove(`${this.endpoint}`);
      return resp;
    })
  );
}

 /**
   * Get hotel details of a the listing with @id
   *
   * @param id - The ID of the listing to retrieve it's details.
   * @returns An observable that emits the details of the specified listing.
   */

 getPrebookById(payload: any) {
  return this.http.post(`${this.endpoint}/ratehawk/prebook`, payload).pipe(
    map((resp: any) => {
      this.cache.remove(`${this.endpoint}/ratehawk/prebook`);
      this.cache.remove(`${this.endpoint}`);
      return resp;
    })
  );
}



}
